import { ByTitleTable } from './ByTitleTable'
import { withByTitleTable } from './withByTitleTable'

const ConnectedByTitleTable = withByTitleTable(ByTitleTable)

export { ConnectedByTitleTable as ByTitleTable }
